<script>
  import { getContext, setContext } from "svelte";
  import { GridContainer, ListColumn } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };
  export let data;

  const isContainerized = !!getContext("containerized");

  if (!isContainerized) {
    setContext("containerized", true);
  }
</script>

{#if isContainerized}
  <ListColumn {data} class={className} />
{:else}
  <GridContainer containerClass={className}>
    <ListColumn {data} />
  </GridContainer>
{/if}
